import axios from "axios";
import { provide } from "vue";

export default {
  data() {
    return {
      axios: axios,
    };
  },
  created() {
    provide("axios", this.axios);

    this.setLoaderSettings();

    this.opts = {
      headers: {},
      withCredentials: true,
    };

    provide("opts", this.opts);
  },
  mounted() {
    this.setLocale(
      localStorage.getItem("lang") ? localStorage.getItem("lang") : false,
    );
  },
  methods: {
    setLocale(value) {
      if (value) {
        this.$root.$i18n.locale = value;
        this.$vuetify.locale.current = value;
      } else {
        this.$root.$i18n.locale = "en";
        this.$vuetify.locale.current = "en";
      }
    },
    setLoaderSettings() {
      this.axios.interceptors.request.use(
        (config) => {
          this.showLoader();
          return config;
        },
        (error) => {
          return Promise.reject(error);
        },
      );

      this.axios.interceptors.response.use(
        (response) => {
          this.hideLoader();
          return response;
        },
        (error) => {
          this.hideLoader();
          return Promise.reject(error);
        },
      );
    },
  },
};
